// extracted by mini-css-extract-plugin
module.exports = {"card":"JZAv-","shadow":"zA8XU","card-title":"JYINS","card-body":"_4P+nj","bordered":"eOR77","clickable":"z1AAn"};